<template>
  <div class="page-head-back" :class="{ border }">
    <span class="page-head-back-btn" @click="handleBack">
      <el-icon>
        <ArrowLeft />
      </el-icon>
      <span>返回</span>
    </span>
    <span class="page-head-back-title">{{ title }}</span>
  </div>
</template>

<script setup>

const emit = defineEmits('back');

defineProps({
  title: String,
  border: {
    type: Boolean,
    default: true
  }
});

const handleBack = () => {
  emit('back');
};

</script>

<style lang="scss">
.page-head-back {
  display: flex;
  height: 22px;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  // cursor: pointer;
  margin-bottom: 16px;
  line-height: 22px;

  &.border {
    padding: 0px 8px;
    height: 40px;
    border-bottom: 1px solid #e3e5e8;
  }

  .page-head-back-btn {
    color: #23272e;
    font-size: 15px;
    font-weight: 500;
    margin-left: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .page-head-back-title {
    font-weight: 400;
    font-size: 15px;
    color: #8C97A6;
    margin-left: 20px;
  }
}
</style>
